import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { SaveInvoiceCharge, UpdateInvoiceCharge } from "../../../services/BillingMaintenanceService"; // Import the service methods
import { NotificationManager } from "react-notifications";
import CommonLoader from "../../common/CommonLoader";

const AddEditInvoiceChargeDialog = ({ open, onClose, editInvoiceCharge }) => {
  const [itemDescription, setItemDescription] = useState("");
  const [price, setPrice] = useState("");
  const [glCode, setGlCode] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editInvoiceCharge) {
      setItemDescription(editInvoiceCharge.itemDescription || "");
      setPrice(editInvoiceCharge.price || "");
      setGlCode(editInvoiceCharge.glCode || "");
    }
  }, [editInvoiceCharge]);

  const validateForm = () => {
    const errors = {};
    if (!itemDescription.trim()) {
      errors.itemDescription = "Item Description is required";
    }
    if (!price || isNaN(price)) {
      errors.price = "Price is required and must be a valid number";
    }
    if (!glCode.trim()) {
      errors.glCode = "GL Code is required";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      try {
        const parsedPrice = parseFloat(price);
        setLoading(true);
        if (editInvoiceCharge) {
          await UpdateInvoiceCharge({itemDescription, parsedPrice, glCode});
          NotificationManager.success("Invoice charge updated successfully");
        } else {
          await SaveInvoiceCharge({itemDescription, parsedPrice, glCode});
          NotificationManager.success("Invoice charge added successfully");
        }
        onClose();
        setLoading(false);
      } catch (error) {
        NotificationManager.error("An error occurred while saving the invoice charge.");
        setLoading(false);
      }
    }
  };

  const handleClose = () => {
    setItemDescription("");
    setPrice("");
    setGlCode("");
    onClose();
  };

  return (
    <>
    
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{editInvoiceCharge ? "Edit Invoice Charge" : "Add New Invoice Charge"}</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <FormControl fullWidth margin="normal" error={!!errors.itemDescription}>
            <TextField
              label="Item Description"
              value={itemDescription}
              onChange={(e) => setItemDescription(e.target.value)}
            />
            {errors.itemDescription && (
              <FormHelperText>{errors.itemDescription}</FormHelperText>
            )}
          </FormControl>
          <FormControl fullWidth margin="normal" error={!!errors.price}>
            <TextField
              label="Price"
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
            {errors.price && (
              <FormHelperText>{errors.price}</FormHelperText>
            )}
          </FormControl>
          <FormControl fullWidth margin="normal" error={!!errors.glCode}>
            <TextField
              label="GL Code"
              value={glCode}
              onChange={(e) => setGlCode(e.target.value)}
            />
            {errors.glCode && (
              <FormHelperText>{errors.glCode}</FormHelperText>
            )}
          </FormControl>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit" variant="contained" color="primary">
              Save
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>

    <CommonLoader loading={loading} />
    </>
  );
};

export default AddEditInvoiceChargeDialog;
